<template>
  <div id="_tlqn_admin_header_user_preview">
    <q-avatar
      :size="size"
      :class="avatarClass"
      class="cursor-pointer"
      v-if="userProfile"
    >
      <!-- 昵称 -->
      {{ ((userProfile || {}).nickname || "").substr(0, 1) }}

      <q-menu :offset="[0, 15]">
        <div style="min-width: 180px">
          <section class="q-pa-md">
            <p class="text-bold q-my-none">欢迎, {{ userProfile.nickname }}</p>
            <p
              class="text-caption text-grey q-mb-xs"
              style="white-space: nowrap"
            >
              {{ userProfile.username }} | {{ userProfile.phone_number }}
            </p>
            <p v-if="currentRole" class="text-caption text-grey q-my-sm">
              <span>已登录为 </span>
              <span class="text-primary">{{ currentRole.description }}</span>
            </p>
          </section>

          <q-separator class="q-mb-sm" />

          <q-list style="min-width: 120px">
            <q-item
              clickable
              dense
              class="row items-center justify-between"
              v-for="or in otherRoles"
              :key="or.to"
              :to="{ path: or.to }"
            >
              <span class="q-mr-sm">切换到{{ or.label }}</span>
              <q-icon name="fas fa-random" size="12px" />
            </q-item>

            <q-separator v-if="otherRoles.length" class="q-my-xs" />

            <q-item
              clickable
              dense
              class="row items-center justify-between text-red"
              @click="logout"
            >
              <span class="q-mr-sm">登出</span>
              <q-icon name="fas fa-sign-out-alt" size="12px" />
            </q-item>
          </q-list>
        </div>
      </q-menu>
    </q-avatar>
    <span v-else>
      <router-link
        :to="{
          path: '/',
        }"
      >
        未登录
      </router-link>
    </span>
  </div>
</template>

<script>
import { getUserProfile } from "@/api/endpoints/auth/getUserProfile";
import { logout } from "@/api/endpoints/auth/logout";
export default {
  props: {
    size: {
      type: String,
      default: "40px",
    },
    avatarClass: {
      default: "bg-primary",
    },
  },
  data() {
    return {
      userProfile: null,
    };
  },

  mounted() {
    this.getUserProfile();
  },

  methods: {
    async getUserProfile() {
      try {
        const response = await getUserProfile(true);
        if (response.status || response.error) {
          this.$q.notify({
            type: "danger",
            message: response.detail || response.message,
          });
        } else {
          this.userProfile = response;
        }
      } catch (err) {
        this.$q.notify({
          type: "danger",
          message: "获取用户信息失败，请检查网络或刷新系统",
        });
      }
    },

    async logout() {
      try {
        const res = await logout();
        if (res.status || res.error)
          this.$q.notify({
            type: "danger",
            message: res.detail || res.message,
          });
        else this.$router.push("/");
      } catch (err) {}
    },
  },

  computed: {
    currentRoleValue() {
      const { userProfile } = this;
      let current;
      if (this.$route.matched.some(({ path }) => path === "/tlqnmbr")) {
        current = "003";
      } else if (this.$route.matched.some(({ path }) => path === "/tlqnad")) {
        current = "001";
      } else if (this.$route.matched.some(({ path }) => path === "/tlqnlder")) {
        current = "002";
      } else if (
        this.$route.matched.some(({ path }) => path === "/tlqntelephoneinterv")
      ) {
        current = "004";
      }
      return current;
    },

    currentRole() {
      const { userProfile, currentRoleValue } = this;
      return (userProfile.roles || []).find(
        (role) => role.value === currentRoleValue
      );
    },

    otherRoles() {
      const { userProfile, currentRoleValue } = this;
      const roles = ((userProfile || {}).roles || []).filter(
        (role) => role.value !== currentRoleValue
      );
      const ors = roles
        .map((role) => {
          return {
            to:
              role.value === "001"
                ? "/tlqnad"
                : role.value === "002"
                ? "/tlqnlder"
                : role.value === "003"
                ? "/tlqnmbr"
                : role.value === "004"
                ? "/tlqntelephoneinterv"
                : "",
            label: role.description,
          };
        })
        .filter(({ to }) => !!to);
      return ors;
    },
  },
};
</script>
